import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_425_2962",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_425_2962)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.9998 19.9722C18.1665 19.9722 16.6434 19.3657 15.4304 18.1528C14.2174 16.9398 13.611 15.4167 13.611 13.5833C13.611 11.75 14.2174 10.2269 15.4304 9.01392C16.6434 7.80094 18.1665 7.19446 19.9998 7.19446C21.8332 7.19446 23.3563 7.80094 24.5693 9.01392C25.7822 10.2269 26.3887 11.75 26.3887 13.5833C26.3887 15.4167 25.7822 16.9398 24.5693 18.1528C23.3563 19.3657 21.8332 19.9722 19.9998 19.9722ZM6.6665 30.5556V29.1667C6.6665 28.1482 6.92345 27.257 7.43734 26.4931C7.95123 25.7292 8.62021 25.1482 9.4443 24.75C11.2591 23.9074 13.0322 23.2755 14.7637 22.8542C16.4952 22.4329 18.2406 22.2223 19.9998 22.2223C21.7591 22.2223 23.4998 22.4375 25.222 22.8681C26.9443 23.2986 28.7121 23.9277 30.5254 24.7554C31.3736 25.1559 32.0536 25.7366 32.5654 26.4975C33.0773 27.2584 33.3332 28.1482 33.3332 29.1667V30.5556C33.3332 31.3195 33.0612 31.9734 32.5172 32.5174C31.9732 33.0613 31.3193 33.3333 30.5554 33.3333H9.44425C8.68037 33.3333 8.02643 33.0613 7.48246 32.5174C6.93849 31.9734 6.6665 31.3195 6.6665 30.5556ZM9.44425 30.5556H30.5554V29.1667C30.5554 28.7685 30.442 28.3935 30.2151 28.0417C29.9883 27.6898 29.7035 27.4259 29.361 27.25C27.6758 26.4259 26.0878 25.8449 24.597 25.507C23.1063 25.169 21.5739 25 19.9998 25C18.4258 25 16.8841 25.169 15.3748 25.507C13.8656 25.8449 12.2776 26.4259 10.611 27.25C10.2684 27.4259 9.98825 27.6898 9.77067 28.0417C9.55306 28.3935 9.44425 28.7685 9.44425 29.1667V30.5556ZM19.9998 17.1945C21.0276 17.1945 21.8864 16.8496 22.5762 16.1597C23.266 15.4699 23.611 14.6111 23.611 13.5833C23.611 12.5556 23.266 11.6968 22.5762 11.007C21.8864 10.3171 21.0276 9.97221 19.9998 9.97221C18.9721 9.97221 18.1133 10.3171 17.4235 11.007C16.7336 11.6968 16.3887 12.5556 16.3887 13.5833C16.3887 14.6111 16.7336 15.4699 17.4235 16.1597C18.1133 16.8496 18.9721 17.1945 19.9998 17.1945Z",
			fill: "#778521"
		})
	})]
});
export default SvgUser;
